import { render } from "./Export.vue?vue&type=template&id=70bca8d4&scoped=true"
import script from "./Export.vue?vue&type=script&lang=js"
export * from "./Export.vue?vue&type=script&lang=js"

import "./Export.vue?vue&type=style&index=0&id=70bca8d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bca8d4"]])

export default __exports__